export const SET_MY_DEFAULT_STORE = 'SET_MY_DEFAULT_STORE';
export const SET_MY_DEFAULT_STORE_ERROR = 'SET_MY_DEFAULT_STORE_ERROR';
export const SET_USER_STORES = 'SET_USER_STORES';
